import React from 'react';
import Image from '../../../components/AppImage';

const MenuHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-[var(--color-primary)]/10 to-[var(--color-accent)]/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 animate-fade-in">
            <div className="inline-block px-4 py-2 bg-[var(--color-primary)]/20 rounded-full">
              <span className="text-sm font-semibold text-[var(--color-primary)]">100% Halal Certified</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[var(--color-foreground)] leading-tight">
              Authentic Flavors,
              <span className="block text-[var(--color-primary)]">Fresh Every Day</span>
            </h1>
            
            <p className="text-lg text-[var(--color-muted-foreground)] max-w-xl">
              Discover our handcrafted menu featuring bold Mexican street food made with premium halal ingredients. Every taco, burrito, and quesadilla is prepared fresh to order with authentic spices and love.
            </p>
            
            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 rounded-full bg-[var(--color-success)]/20 flex items-center justify-center">
                  <span className="text-2xl">🌱</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[var(--color-foreground)]">Fresh Daily</p>
                  <p className="text-xs text-[var(--color-muted-foreground)]">Made to order</p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 rounded-full bg-[var(--color-primary)]/20 flex items-center justify-center">
                  <span className="text-2xl">🔥</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[var(--color-foreground)]">Bold Flavors</p>
                  <p className="text-xs text-[var(--color-muted-foreground)]">Authentic spices</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative animate-slide-up">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src="https://images.unsplash.com/photo-1605209763272-b5f7265d8ed5"
                alt="Colorful array of authentic Mexican tacos with fresh cilantro, lime wedges, grilled meat, and vibrant salsa on rustic wooden serving board"
                className="w-full h-[400px] lg:h-[500px] object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                  <p className="text-sm font-semibold text-[var(--color-foreground)]">Today's Special</p>
                  <p className="text-xs text-[var(--color-muted-foreground)] mt-1">Spicy Chicken Tacos with Mango Salsa</p>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-[var(--color-accent)] rounded-full flex items-center justify-center shadow-lg animate-pulse-subtle">
              <div className="text-center">
                <p className="text-2xl font-bold text-white">₹99</p>
                <p className="text-xs text-white/90">Starting</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default MenuHero;